// React and related imports
import React, { useState } from 'react';

// React Icons
import { HiEye, HiEyeOff } from 'react-icons/hi';

// i18n translation
import { TFunction } from 'i18next';

interface AlertContentVisibilityProps {
  t: TFunction<'translation', undefined>;
  errors: string[];
}

export const AlertContentVisibility: React.FC<AlertContentVisibilityProps> = ({
  t,
  errors,
}) => {
  const [isContentVisible, setIsContentVisible] = useState(true);

  const toggleContentVisibility = () => {
    setIsContentVisible((prevState) => !prevState);
  };

  return (
    <>
      {isContentVisible && (
        <div className="flex flex-col gap-1 px-8 py-2">
          {errors.map((error, i) => (
            <span key={i} className="font-medium">
              • {t(`errorMessages.${error}`)}
            </span>
          ))}
        </div>
      )}

      {/* Toggle Button */}
      <div className="flex justify-end">
        <button
          type="button"
          className="text-gray-600 dark:text-gray-400"
          onClick={toggleContentVisibility}
        >
          {isContentVisible ? <HiEyeOff size={20} /> : <HiEye size={20} />}
        </button>
      </div>
    </>
  );
};
